// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__o3sUI","customerLabel":"ConfirmDeleteModal_customerLabel__N8aBx","customerBtn":"ConfirmDeleteModal_customerBtn__6Dlm6"};